/* eslint-disable */
"use strict";

var config, service;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.service_modbus || process.env.VUE_APP_service_modbus;
})();

async function writeCoil(ip, address, value) {
  const data = {
    ip,
    address,
    value,
  };
  try {
    const response = await fetch(`${service}/writeCoil`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return { status: "error", message: error.message };
  }
}

async function pulseCoil(ip, address, timeout) {
  const data = {
    ip,
    address,
    timeout,
  };
  try {
    const response = await fetch(`${service}/pulseCoil`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return { status: "error", message: error.message };
  }
}

export default {
  writeCoil,
  pulseCoil,
};
